import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject
} from "@angular/core";
import { JobService } from "@app/integrations/urm/services/job.service";
import { JobFile } from "@app/integrations/urm/models/job-file";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "urm-job-description-widget",
  templateUrl: "./job-description-widget.component.html",
  styleUrls: ["./job-description-widget.component.css"],
  imports: [MatProgressBar, MatIcon]
})
export class JobDescriptionWidgetComponent implements OnChanges {
  protected jobService = inject(JobService);

  @Input()
  public externalJobReference: string = null;
  @Input()
  public compact: boolean = false;
  public loading = true;
  public error = false;
  public errorMessage = "";
  public jobRecord: JobFile;
  private promise: Promise<JobFile>;

  sync() {
    this.jobRecord = null;
    this.promise = this.jobService.loadJobById(this.externalJobReference);
    this.promise.then(
      (value) => {
        this.loading = false;
        console.log("job result", value, this.externalJobReference);
        if (value.Jobf_JobId.trim() === this.externalJobReference) {
          console.log("matched result");
          this.jobRecord = value;
        } else {
          // this.jobRecord = null;
        }
        this.error = false;
        this.errorMessage = "";
        this.loading = false;
      },
      (reason) => {
        this.error = true;
        this.loading = false;
        console.log(reason);
        this.errorMessage = reason;
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changed", changes);
    this.sync();
  }
}
